import { Box, Tab, Tabs } from '@mui/material';
import { common } from '@mui/material/colors';
import { colors } from 'common/constants';
import React from 'react';
import DiscountPackageService from './components/discount-package-service';
import DiscountSurveyService from './components/discount-survey-service';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box mt={3}>{children}</Box>}
        </div>
    );
}

export function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Discount: React.FC = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box>
            <Box sx={{ width: '30%', mx: 'auto', mt: 3 }}>
                <Tabs
                    centered
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    sx={{
                        border: `1px solid ${colors.main}`,
                        backgroundColor: (theme) => theme.palette.common.white,
                        borderRadius: '50px',
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: '700',
                            color: colors.main,
                        },
                        '& .Mui-selected': {
                            color: `${common.white} !important`,
                            fontWeight: '700',
                            backgroundColor: colors.main,
                            borderRadius: '50px',
                        },
                        '& .MuiTabs-indicator': {
                            display: 'none',
                        },
                    }}
                >
                    <Tab
                        label="Gói dịch vụ"
                        {...a11yProps(0)}
                        disableRipple
                        sx={{ flex: 1 }}
                    />
                    <Tab
                        label="Dịch vụ khảo sát"
                        {...a11yProps(1)}
                        disableRipple
                        sx={{ flex: 1 }}
                    />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <DiscountPackageService />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <DiscountSurveyService />
            </CustomTabPanel>
        </Box>
    );
};

export default Discount;
